import type { LayerState } from '@vitals/shared';
import type { VitalDef } from './vitals.js';

/**
 * Vital selector for FloodNet street flooding.
 *
 * Display: value = flooding-sensor count, label "flooding".
 * 0 flooding → tone good. Deep flooding (≥12″) → tone bad.
 * Down/no-summary: value "—".
 */
export const floodVital: VitalDef = {
  id: 'flood',
  layerId: 'floodnet',

  select(s: LayerState | undefined) {
    const isDown = !s || s.status === 'down' || s.summary == null;
    if (isDown) {
      return {
        value: '—',
        label: 'flooding',
        down: true,
        stale: false,
      };
    }

    const stale = s.status === 'stale';
    const { flooding, maxDepthIn } = s.summary as { flooding: number; maxDepthIn: number };

    if (flooding === 0) {
      return { value: '0', label: 'flooding', down: false, stale, tone: 'good' };
    }

    return {
      value: `${flooding}`,
      label: 'flooding',
      down: false,
      stale,
      tone: maxDepthIn >= 12 ? 'bad' : 'warn',
    };
  },
};
